import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionKConsistency = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
        // eslint-disable-next-line
        const payload = input;
    }
    else if (!field) {
        // section level
        // eslint-disable-next-line
        const payload = input;
    }
    else {
        // field level
        if (field === 'k0520') {
            const payload = input;
            // K-consistency-5930 (a) If K0520Z1=[1], then all active items from K0520A1 through K0520D1 must equal [0].
            if (payload && payload.includes('Z') && payload.length > 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-5930 (a) If 'None of the above' is checked, then all items from A through D must equal NOT be checked`,
                    path: [],
                });
            }
            // K-consistency-5930 (b) If K0520Z1=[0], then at least one active item from K0520A1 through K0520D1 must equal [1], and the remaining items must equal [0,1].
            if (payload && !payload.includes('Z') && !payload.some((item) => ['A', 'B', 'C', 'D'].includes(item))) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-5930 (b) If 'None of the above' is NOT checked, then at least one active item from A through D must be checked`,
                    path: [],
                });
            }
            // (c) If K0520Z1=[-], then at least one active item from K0520A1 through K0520D1 must equal [-], and the remaining items must equal [0,-].
        }
    }
};
// K-consistency-5930
// (a) If K0520Z1=[1], then all active items from K0520A1 through K0520D1 must equal [0].
// (b) If K0520Z1=[0], then at least one active item from K0520A1 through K0520D1 must equal [1], and the remaining items must equal [0,1].
// (c) If K0520Z1=[-], then at least one active item from K0520A1 through K0520D1 must equal [-], and the remaining items must equal [0,-].
// K-consistency-5940
// (a) If K0520Z4=[1], then all active items from K0520A4 through K0520D4 must equal [0].
// (b) If K0520Z4=[0], then at least one active item from K0520A4 through K0520D4 must equal [1], and the remaining items must equal [0,1].
// (c) If K0520Z4=[-], then at least one item from K0520A4 through K0520D4 must equal [-], and the remaining active items must equal [0,-].
// K-consistency-5950
// (a) If K0520Z5=[1], then all active items from K0520A5 through K0520D5 must equal [0].
// (b) If K0520Z5=[0], then at least one active item from K0520A5 through K0520D5 must equal [1], and the remaining items must equal [0,1].
// (c) If K0520Z5=[-], then at least one active item from K0520A5 through K0520D5 must equal [-], and all remaining active items must equal [0,-].
